import { finishExternalForm } from '@/domain/external/actions/finish-external-form.action';
import { useAppDispatch } from '@/ui/hook/store';

export function useExternalInvitationUpdate() {
  const dispatch = useAppDispatch();

  const changeInvitationStatusToSubmit = () => {
    dispatch(finishExternalForm());
  };

  return { changeInvitationStatusToSubmit };
}
